import { NavItem } from '@billy/design-system'

import { InvoiceDiscountType } from '../enums/invoiceDiscountType'

export const getInvoiceDiscountTypeSelectItems = (currency: string): NavItem<InvoiceDiscountType>[] => [
  { children: '%', id: InvoiceDiscountType.Percentage, value: InvoiceDiscountType.Percentage },
  { children: currency, id: InvoiceDiscountType.Amount, value: InvoiceDiscountType.Amount },
]
